import { defineComponent } from "vue";

/**
 * 渲染 `EarlyMorning` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const EarlyMorning = defineComponent({
	name: "EarlyMorning",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M928 303.36H752.2944c89.728 96 121.82912 238.65856 70.656 369.1904-70.92096 180.91648-274.93248 270.016-455.66336 199.01824A350.464 350.464 0 0 1 176.64 691.712c13.90464 8.63488 29.50656 17.87904 45.29024 24.0768 140.86528 55.33312 299.85664-14.1184 355.136-155.10784 34.2784-87.43808 19.48544-183.63904-30.2656-257.32096H96a32 32 0 0 1 0-64h832a32 32 0 0 1 0 64zM160 128h704a32 32 0 0 1 0 64H160a32 32 0 0 1 0-64z m96.64 203.52l31.84896 57.92256L353.2672 401.92l-45.09312 48.27776 8.192 65.63328-59.72608-28.08448L196.91904 515.84l8.192-65.63328L160.0128 401.92l64.77696-12.47872L256.64 331.52m142.08 184.32l22.56896 41.43104 45.90208 8.92544-31.95264 34.5344L441.03808 647.68 398.72 627.584 356.40192 647.68l5.79968-46.94656-31.95264-34.53184 45.90208-8.92544L398.72 515.84"></path>
			</svg>
		);
	},
});

export default EarlyMorning;
